<template>
  <button
    id="mButton"
    class="m-button1 vld-parent"
    :class="[
      'button-type-' + buttonOptions.type,
      'button-size-' + buttonOptions.size,
      buttonOptions.rounded ? 'rounded-full' : 'rounded-lg',
    ]"
    :disabled="buttonOptions.disabled || isButtonLoading"
  >
    <loading :active="isButtonLoading" :is-full-page="false" background-color="#b1b3b1">
      <div>
        <Lottie small-size />
      </div>
    </loading>
    <div class="flex items-center justify-center">
      <nuxt-icon v-if="buttonOptions.leftIcon" class="inline-block button-icon mr-2" name="arrow-left" />
      <span>
        {{ buttonOptions.text }}
      </span>
      <nuxt-icon v-if="buttonOptions.rightIcon" class="button-icon ml-2" name="arrow-right" />
    </div>
  </button>
</template>

<script>
export default {
  props: {
    buttonOptions: {
      type: Object,
      default: function () {
        return {
          href: null,
          target: true,
          text: null,
          type: 'primary',
          size: 'normal',
          rightIcon: true,
          leftIcon: false,
          rounded: false,
          disabled: false,
        };
      },
    },
    isButtonLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
#mButton {
  .button-icon {
    @apply text-base;
  }
}
</style>
